import React from 'react';

import { Error } from './error';

export const VedleggError = () => (
    <Error headerText="Feil ved vedlegg">
        <p>
            Vi får ikke sendt inn skademeldingen din på grunn av feil med vedlegg. Gå tilbake og last opp vedlegg på
            nytt.
        </p>
        <p>
            Dersom problemet gjentar seg flere ganger, kan du sende inn skademeldingen uten vedlegg, og så hjelper vi
            deg videre.
        </p>
    </Error>
);
